import secureLocalStorage from "react-secure-storage";
import React, { Component } from "react";
import { Popup } from "@progress/kendo-react-popup";
import { PanelBar, PanelBarItem } from "@progress/kendo-react-layout";
import { DropDownList, MultiSelect } from "@progress/kendo-react-dropdowns";
import { NumericTextBox, TextArea } from "@progress/kendo-react-inputs";
import { Input } from "@progress/kendo-react-inputs";
import Chip from "@material-ui/core/Chip";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { toastr } from "react-redux-toastr";
import { CircularProgress } from "@material-ui/core";
import { DatePicker } from "@progress/kendo-react-dateinputs";
import { GridColumn } from "@progress/kendo-react-grid";
import Api from "../../Services/Api";
import moment from "moment";
import { mapTree } from "@progress/kendo-react-treelist";
import {CustomDateInput} from "../CustomDateInput";

const approvedList = [
  { text: "Yes", value: true },
  { text: "No", value: false },
];

const STATUS = [
  { text: "Open", value: false },
  { text: "Closed", value: true },
];
export default class TaskActionRegisterFormView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      expandMode: "multiple",
      customFieldReq: [],
      impactFieldReq: [],
      impactResponse: [],
      taskActionTitle: "",
      taskActionDescription: "",
      effort: 0,
      existingControl: "",
      taskOwner: {},
      isClosed: STATUS[0],
      percentageOnTrack: 0,
      percentageCompletion: 0,
      proximityAlertDate: null,
      originalCompletionDate: null,
      projectedCompletionDate: null,
      actualCompletionDate: null,
      delayConsequence: null,
      alertStakeHolders: [],
      alertDescription: "",
      postProbability: 0,
      currentProbability: 0,
      isDonePopulate: false,
      loader: false,
      isApproved: approvedList[1],
      formEditFlag: false,
      formData: {},
      temptaskActionTitle: false,
      impactslist: [],
      probabilityRangeMaster: {},
      weightageList: [],
      qualitativeImpactslist: [],
      openImpactRatingFlag: false,
      skip: 0,
      take: Math.round((window.innerHeight - 250) / 35),
      probabilityvalue: "",
      orgUnit: this.getWorkstreamObj(),
      taskTitle: "",
      taskDescription: "",
      progressComment: "",
      departments: "",
      externalStatus: "",
      weeklyReport: "",
    };
    this.init = this.init.bind(this);
    this.getDisableFlagForSubmit = this.getDisableFlagForSubmit.bind(this);
  }

  getWorkstreamObj = () => {
    let orgUnit = {};
    mapTree(this.props.organisationUnitList, "children", (item) => {
      if (item.unitId === this.props.dataItem?.organizationUnitId) {
        orgUnit = item;
      }
      return item;
    });
    return orgUnit;
  };
  componentDidMount = () => {
    if (this.props.formEditFlag === true) {
      console.log("vvv", this.props.formData);
      this.loadEditmode(this.props.formData);
    }
  };
  loadEditmode = async (formData) => {
    await this.populateFormData(formData);
  };
  getImpactRatingTable = async () => {
    try {
      this.setState({ loader: true });
      var req = {
        WorkstreamId: this.state.orgUnit?.unitId,
      };
      let response = await Api.getImpactRatingTable(req);
      if (response.status === 200 && response.impactRatingTable) {
        let wlist = response.impactRatios ? response.impactRatios : [];

        this.dynamicColsQuantitative(
          response.impactRatingTable,
          response.probabilityRangeResponse
        );
        this.dynamicColsQualititative(
          response.qualityimpactRatingTable,
          response.probabilityRangeResponse
        );

        let arr = response.probabilityRangeResponse;
        let array = response.probabilityRangeResponse;
        let rangeArray = [];
        let probabilityObj = {};
        let probabilityval = {};

        arr = arr?.map((item) => {
          item[item.fullDescription] = item.probabilityRangeValue;
          probabilityObj = { ...probabilityObj, ...item };
          return item;
        });
        array = array?.map((item) => {
          item[item.probabilityDescription] = item.probabilityRangeValue;
          probabilityval = { ...probabilityval, ...item };
          return item;
        });
        rangeArray = arr.map((column, index) => (
          <GridColumn
            key={index}
            field={column.fullDescription}
            title={column.fullDescription + " From"}
            editor="numeric"
            width="110px"
            format="{0:##,#}"
            editable={false}
          />
        ));
        let probabilityArray = array.map((column, index) => (
          <GridColumn
            key={index}
            field={column.probabilityDescription}
            title={column.probabilityDescription + " From"}
            editor="numeric"
            width="110px"
            format="{0:##,#}"
            editable={false}
          />
        ));

        this.setState({
          ...this.state,
          loader: false,
          openImpactRatingFlag: true,
          impactslist: response.impactRatingTable,
          probabilityRangeMaster: [probabilityval],
          weightageList: wlist,
          qualitativeImpactslist: response.qualityimpactRatingTable,
          probabilityColumns: rangeArray,
          probabilityvalue: probabilityArray,
        });
      } else {
        this.setState({
          ...this.state,
          loader: false,
          impactslist: [],
          probabilityRangeMaster: [],
          weightageList: [],
          qualitativeImpactslist: [],
        });
      }
    } catch (error) {
      console.error(error);
      this.setState({
        ...this.state,
        loader: false,
        impactslist: [],
        probabilityRangeMaster: [],
        weightageList: [],
        qualitativeImpactslist: [],
      });
    }
  };
  dynamicColsQuantitative = (data, probabilityRangeResponse) => {
    try {
      data.map((res) => {
        res.impactThresholdValue.map((item) => {
          let field = this.getFieldName(item.orderId, probabilityRangeResponse);
          res[field] = item.thresholdValue;
        });
      });
    } catch (error) {
      // this.setState({ ...this.state, loader: false });
      console.error(error);
    }
  };
  dynamicColsQualititative = (data, probabilityRangeResponse) => {
    try {
      data.map((res) => {
        res.qualitativeImpactValue.map((item) => {
          let field = this.getFieldName(item.orderId, probabilityRangeResponse);
          res[field] = item.qualitativeValue;
        });
      });
    } catch (error) {
      // this.setState({ ...this.state, loader: false });
      console.error(error);
    }
  };
  getFieldName = (orderId, probabilityRangeResponse) => {
    let obj = probabilityRangeResponse.find((item) => item.orderId === orderId);
    return obj?.fullDescription;
  };
  processInput = (input) => {
    if (typeof input === "string") {
      return input.split(",").map((item) => item.trim()); // Optional: trim spaces around items
    } else if (Array.isArray(input)) {
      return input;
    } else {
      return [];
    }
  };
  populateFormData = async (formData) => {
    try {
      let isApproved = approvedList.find(
        (item) =>
          item.value === formData.isApproved ||
          item.text === formData.isApproved
      );
      let isClosed = STATUS.find(
        (item) =>
          item.text === formData.isClosed || item.value === formData.isClosed
      );
      let taskOwner = this.props.ownerListForRisk.find(
        (item) => item.value === formData.ownerId
      );
      let priorityRanking = this.props.priorityRankingsList?.find(
        (item) => item.value === formData.priorityRankingId
      );

      this.setState({
        ...this.state,
        formEditFlag: true,
        formData: formData,
        customFieldReq: await this.constructCFState(formData),
        taskActionTitle: formData.taskActionTitle,
        taskActionDescription: formData.taskActionDescription,
        isApproved: isApproved,
        cost: formData.cost,
        effort: formData.effort,
        taskOwner: taskOwner,
        isClosed: isClosed,
        percentageOnTrack: formData.percentageOnTrack,
        percentageCompletion: formData.percentageCompletion,
        proximityAlertDate: formData.proximityAlertDate
          ? new Date(formData.proximityAlertDate)
          : null,
        originalCompletionDate: formData.originalCompletionDate
          ? new Date(formData.originalCompletionDate)
          : null,
        projectedCompletionDate: formData.projectedCompletionDate
          ? new Date(formData.projectedCompletionDate)
          : null,
        actualCompletionDate: formData.actualCompletionDate
          ? new Date(formData.actualCompletionDate)
          : null,
        delayConsequence: formData.delayConsequence,
        progressComment: formData.progressComment,
        alertStakeHolders: this.processInput(formData.alertStakeHolders),
        alertDescription: formData.alertDescription,
        priorityRanking: priorityRanking,
        isDonePopulate: true,
        loader: false,
        taskTitle: formData.taskTitle,
        taskDescription: formData.taskDescription,
        departments: formData.departments,
        externalStatus: formData.externalStatus,
        weeklyReport: formData.weeklyReport,
      });
    } catch (err) {
      console.error(err);
    }
  };
  constructCFState = (formData) => {
    let arr = [];
    try {
      formData.customFields.map((cf) => {
        let temp = this.state.orgUnit?.customFields?.find(
          (item) => item.customFieldId === cf.id
        );
        // console.log("aaaa",aaaa);
        if (cf.inputType == "Multi Drop Down") {
          arr.push({
            CustomFieldId: cf.id,
            inputType: cf.inputType,
            value: temp?.cfPossibleValues.filter((item) =>
              cf.selectedCustomFieldIds.includes(item.id)
            ),
          });
        } else if (cf.inputType == "Single Drop Down") {
          arr.push({
            CustomFieldId: cf.id,
            inputType: cf.inputType,
            value: cf.cfPossibleValues.find((item) =>
              cf.selectedCustomFieldIds.includes(item.id)
            ),
          });
        } else if (cf.inputType == "Free Text") {
          arr.push({
            CustomFieldId: cf.id,
            inputType: cf.inputType,
            value: cf.multiText,
          });
        } else if (cf.inputType == "Numeric") {
          arr.push({
            CustomFieldId: cf.id,
            inputType: cf.inputType,
            value: cf.multiText,
          });
        } else if (cf.inputType == "Date") {
          arr.push({
            CustomFieldId: cf.id,
            inputType: cf.inputType,
            value: cf.multiText ? new Date(cf.multiText) : null,
          });
        }
      });
      // this.setState({ ...this.state, customFieldReq: arr });
      return arr;
    } catch (err) {
      console.error(err);
      return [];
    }
  };

  handleCustomFieldValue = (e, CfItem) => {
    try {
      let cfObj = {
        CustomFieldId: CfItem.customFieldId,
        inputType: CfItem.inputType,
        value: CfItem.inputType === "Date" ? e.target.value : e.value,
      };
      let arr = this.state.customFieldReq;
      if (arr.some((item) => item.CustomFieldId === CfItem.customFieldId)) {
        let index = arr.findIndex(
          (item) => item.CustomFieldId == CfItem.customFieldId
        );
        arr[index] = cfObj;
      } else {
        arr.push(cfObj);
      }
      this.setState({ ...this.state, customFieldReq: arr });
    } catch (err) {
      console.error(err);
    }
  };
  handleImpactFieldValue = (e, impact) => {
    try {
      let impactObj = {
        impactId: impact.impactId,
        impactType: impact.impactType,
        value: e.value,
      };
      let arr = this.state.impactFieldReq;
      if (arr.some((item) => item.impactId === impact.impactId)) {
        let index = arr.findIndex((item) => item.impactId == impact.impactId);
        // console.log("index", index);
        arr[index] = impactObj;
      } else {
        arr.push(impactObj);
      }
      // console.log("arr", arr);
      this.setState({ ...this.state, impactFieldReq: arr });
    } catch (err) {
      console.error(err);
    }
  };

  saveTaskAction = async () => {
    //AddRiskRegister
    this.setState({ ...this.state, loader: true, isDonePopulate: true });
    try {
      let percentageCompletion = this.state.percentageCompletion;
      let isClosed = this.state.isClosed ? this.state.isClosed.value : false;
      let actualCompletionDate = this.state.actualCompletionDate;
      let projectedCompletionDate = this.state.projectedCompletionDate;
      let originalCompletionDate = this.state.originalCompletionDate;

      if (percentageCompletion >= 100) {
        isClosed = true;
        actualCompletionDate = new Date();
      }
      if (percentageCompletion >= 100 && !actualCompletionDate) {
        isClosed = true;
        actualCompletionDate = new Date();
      }

      if (isClosed === false) {
        actualCompletionDate = null;
      }

      if (actualCompletionDate) {
        isClosed = true;
      }

      if (this.state.originalCompletionDate && !projectedCompletionDate) {
        projectedCompletionDate = this.state.originalCompletionDate;
      }
      if (this.state.projectedCompletionDate && !originalCompletionDate) {
        originalCompletionDate = this.state.projectedCompletionDate;
      }

      let request = {
        taskRegisterId: this.props.taskDetails
          ? this.props.taskDetails.taskRegisterId
          : 0,
        taskActionId:
          this.state.formEditFlag === true
            ? this.state.formData.taskActionId
            : 0,
        isApproved: this.state.isApproved ? this.state.isApproved.value : false,
        taskActionTitle: this.state.taskActionTitle?.slice(0, 30),
        taskActionDescription: this.state.taskActionDescription,
        cost: this.state.cost,
        effort: this.state.effort,
        taskOwner: this.state.taskOwner,
        ownerId: this.state.taskOwner ? this.state.taskOwner.value : 0,
        isClosed: isClosed,
        percentageOnTrack:
          this.state.percentageOnTrack > 100
            ? 100
            : this.state.percentageOnTrack,
        percentageCompletion:
          percentageCompletion > 100 ? 100 : percentageCompletion,

        proximityAlertDate: this.state.proximityAlertDate
          ? moment(this.state.proximityAlertDate).format("YYYY-MM-DD")
          : null,
        originalCompletionDate: originalCompletionDate
          ? moment(originalCompletionDate).format("YYYY-MM-DD")
          : null,
        projectedCompletionDate: projectedCompletionDate
          ? moment(projectedCompletionDate).format("YYYY-MM-DD")
          : null,
        actualCompletionDate: actualCompletionDate
          ? moment(actualCompletionDate).format("YYYY-MM-DD")
          : null,

        delayConsequence: this.state.delayConsequence,
        alertStakeHolders: this.processInput(this.state.alertStakeHolders),
        alertDescription: this.state.alertDescription,
        priorityRankingId: this.state.priorityRanking?.value,

        progressComment: this.state.progressComment,
        departments: this.state.departments,
        externalStatus: this.state.externalStatus,
        weeklyReport: this.state.weeklyReport,
      };

      let response = await Api.addTaskAction(request);
      if (response.status === 200) {
        await this.init("RESET");
        if (request.number) {
          this.props.addRiskDataFromForm("UPDATE", response.riskReg);
          this.init("CANCEL");
        } else {
          toastr.success(response.message);
          this.props.addRiskDataFromForm("ADD", response.riskReg);
          this.init("CANCEL");
        }
        this.setState({ ...this.state, loader: false });
      } else {
        toastr.error(response.message);
        this.setState({ ...this.state, loader: false });
      }
    } catch (err) {
      console.error(err);
      this.setState({ ...this.state, loader: false });
    }
  };
  changeCFKeyName = (cfArray) => {
    let arr = [];
    try {
      cfArray.forEach((element) => {
        if (element.inputType == "Multi Drop Down") {
          arr.push({
            CustomFieldId: element.CustomFieldId,
            inputType: element.inputType,
            MultiDropDownValue: element.value,
          });
        } else if (element.inputType == "Single Drop Down") {
          arr.push({
            CustomFieldId: element.CustomFieldId,
            inputType: element.inputType,
            SingleDropDownValue: element.value,
          });
        } else if (element.inputType == "Free Text") {
          arr.push({
            CustomFieldId: element.CustomFieldId,
            inputType: element.inputType,
            FreeTextValue: element.value,
          });
        } else if (element.inputType == "Numeric") {
          arr.push({
            CustomFieldId: element.CustomFieldId,
            inputType: element.inputType,
            NumericValue: element.value,
          });
        } else if (element.inputType == "Date") {
          arr.push({
            CustomFieldId: element.CustomFieldId,
            inputType: element.inputType,
            DateValue: element.value,
          });
        }
      });
    } catch (err) {
      console.error(err);
    }
    return arr;
  };
  getCFValue = (cf) => {
    try {
      let obj =
        this.state.customFieldReq &&
        this.state.customFieldReq.find(
          (item) => item.CustomFieldId === cf.customFieldId
        );

      if (obj) {
        return obj.value;
      } else {
        return "";
      }
    } catch (err) {
      console.error(err);
    }
    return;
  };
  getImpactValue = (impact) => {
    try {
      let impactObj = this.state.impactFieldReq.find(
        (item) => item.impactId === impact.impactId
      );
      if (impactObj && impact.impactType === "Quantitative") {
        return impactObj.value;
      } else if (impactObj && impact.impactType === "Qualitative") {
        return impactObj.qValue ? impactObj.qValue : impactObj.value;
      }
    } catch (err) {
      console.error(err);
    }
    return 0;
  };

  itemRender = (li, itemProps) => {
    const itemChildren = (
      <span>
        <input
          type="checkbox"
          checked={itemProps.selected}
          onChange={() => {}}
        />
        &nbsp;{li.props.children}
      </span>
    );
    return React.cloneElement(li, li.props, itemChildren);
  };

  init = async (flag) => {
    if (flag == "CANCEL") {
      this.setState({
        customFieldReq: [],
        impactFieldReq: [],
        impactResponse: [],
        taskActionTitle: "",
        taskActionDescription: "",
        cost: 0,
        effort: 0,
        existingControl: "",
        taskOwner: {},
        isClosed: STATUS[0],
        percentageOnTrack: 0,
        percentageCompletion: 0,
        proximityAlertDate: null,
        originalCompletionDate: null,
        projectedCompletionDate: null,
        actualCompletionDate: null,
        delayConsequence: null,
        alertStakeHolders: [],
        alertDescription: "",
        postProbability: 0,
        currentProbability: 0,
        departments: "",
        externalStatus: "",
        weeklyReport: "",
        isDonePopulate: false,
        priorityRanking: null,
        formEditFlag: false,
        loader: false,
      });
      this.props.closeRiskFormView();
    } else {
      this.setState({
        customFieldReq: [],
        impactFieldReq: [],
        impactResponse: [],
        taskActionTitle: "",
        taskActionDescription: "",
        cost: 0,
        effort: 0,
        existingControl: "",
        taskOwner: {},
        isClosed: STATUS[0],
        percentageOnTrack: 0,
        percentageCompletion: 0,
        proximityAlertDate: null,
        originalCompletionDate: null,
        projectedCompletionDate: null,
        actualCompletionDate: null,
        delayConsequence: null,
        alertStakeHolders: [],
        alertDescription: "",
        postProbability: 0,
        currentProbability: 0,
        departments: "",
        externalStatus: "",
        weeklyReport: "",
        formEditFlag: false,
        priorityRanking: null,
        loader: false,
      });
    }
  };

  getImpactCurrentAndPostValue = (impact, type) => {
    try {
      if (this.state.formEditFlag === true) {
        let impactObj =
          this.state.impactResponse &&
          this.state.impactResponse.find(
            (item) => item.impactId === impact.impactId && item.type === type
          );
        if (
          impactObj &&
          impactObj.type === "Current" &&
          impact.impactType === "Quantitative"
        ) {
          return impactObj.currentImpactValue;
        } else if (
          impactObj &&
          impactObj.type === "Post" &&
          impact.impactType === "Quantitative"
        ) {
          return impactObj.postImpactValue;
        } else if (
          impactObj &&
          impactObj.type === "Current" &&
          impact.impactType === "Qualitative"
        ) {
          return impactObj.currentQvalue;
        } else if (
          impactObj &&
          impactObj.type === "Post" &&
          impact.impactType === "Qualitative"
        ) {
          return impactObj.postQvalue;
        }
      }
    } catch (err) {
      console.error(err);
    }
  };

  riskalertstakeholderValue = (e, values) => {
    var val = [];
    val = values[values.length - 1];
    let mailvalidity = /^([a-zA-Z0-9\._]+)@([a-zA-Z0-9])+.([a-z]+)(.[a-z]+)?$/;

    if (
      val &&
      (val.trim().length == 0 ||
        (!(val.includes("(") && val.includes(")")) &&
          mailvalidity.test(val) == false))
    ) {
      toastr.error("Please enter a valid email address");
    } else {
      this.setState({
        ...this.state,
        alertStakeHolders: values,
      });
    }
  };

  taskActionTitleValue = (e) => {
    var val = e.target.value.trim();
    if (val == 0) {
      this.setState({
        ...this.state,
        taskActionTitle: e.target.value,
        temptaskActionTitle: true,
      });
    } else {
      this.setState({
        ...this.state,
        taskActionTitle: e.target.value,
        temptaskActionTitle: false,
      });
    }
  };

  getDisableFlag = () => {
    let flag = false;
    const loginUserId = parseInt(secureLocalStorage.getItem("loginUserId"));
    const ownerId = this.state.formData.ownerId;
    const role = this.props.role;
    const isClosed = !this.state.isClosed
      ? this.state.formData.isClosed === "Open" ||
        this.state.formData.isClosed === false
        ? false
        : true
      : this.state.isClosed.value === true ||
        this.state.isClosed.value === "Closed"
      ? true
      : false;
    if (isClosed === true) {
      flag = true;
    } else if (loginUserId === ownerId) {
      flag = false;
    } else if (role === "View Only" || role === "Standard User") {
      flag = true;
    }
    return flag;
  };

  getDisableFlagForSubmit = () => {
    let flag = false;
    const loginUserId = parseInt(secureLocalStorage.getItem("loginUserId"));
    const ownerId = this.state.formData.ownerId;
    const role = this.state.formData.roleName;
    const isClosed = !this.state.isClosed
      ? this.state.formData.isClosed === "Open" ||
        this.state.formData.isClosed === false
        ? false
        : true
      : this.state.isClosed.value === true ||
        this.state.isClosed.value === "Closed"
      ? true
      : false;

    // if (isClosed === true ) {
    //   flag = true;
    // }else
    if (loginUserId === ownerId) {
      flag = false;
    } else if (role === "View Only" || role === "Standard User") {
      flag = true;
    } else if (
      !this.state.taskActionTitle ||
      this.state.taskActionTitle === ""
    ) {
      flag = true;
    }
    return flag;
  };

  impactRatingClose = () => {
    this.setState({ openImpactRatingFlag: false });
  };
  openImpactRatingTable = () => {
    this.getImpactRatingTable();
  };
  pageChange = (event) => {
    this.setState({ skip: event.page.skip, take: event.page.take });
  };
  progressHistory = () => {
    this.setState({ ...this.state, progressStatusFlag: true });
  };

  closeProgressHistoryPopup = () => {
    this.setState({ ...this.state, progressStatusFlag: false });
  };
  isHiddenActivityColumn = (field) => {
    return !this.props.selectedActivitiesColumnFields?.some(
      (item) => item.fieldName === field
    );
  };
  render() {
    const { expandMode } = this.state;
    const isDisabled = this.getDisableFlag();
    console.log("this.props.orgUnit", this.state.orgUnit);
    return (
      <div>
        <Popup
          show={this.props.showFormView}
          popupClass={"popup-content popup-wrapper"}
        >
          <div className="addriskFormview">
            <div className="Formview">
              <h3>
                {this.state.formEditFlag === true
                  ? "Update Activity - " + this.state.formData.taskActionNumber
                  : "Add Activity "}{" "}
              </h3>
              {/* <div className="RatingTablebtn" title="Rating Table">
                <a onClick={() => this.openImpactRatingTable()}>Rating Table</a>
              </div> */}
            </div>
            {this.state.loader ? (
              <span className="MatTableSpinner">
                <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
              </span>
            ) : null}

            <PanelBar expandMode={expandMode}>
              <PanelBarItem title={"Task Information"} expanded={true}>
                <div className="riskRow">
                  <div className="riskCol col2">
                    <div
                      className="fieldCont"
                      title={
                        this.props.taskDetails?.taskTitle ||
                        this.state.taskTitle
                      }
                    >
                      <label>Task Title</label>

                      <Input
                        value={
                          this.props.taskDetails?.taskTitle ||
                          this.state.taskTitle
                        }
                        disabled={true}
                      />
                    </div>
                  </div>
                  <div className="riskCol col6">
                    <div
                      className="fieldCont"
                      title={
                        this.props.taskDetails?.taskDescription ||
                        this.state.taskDescription
                      }
                    >
                      <label>Task Description</label>

                      <Input
                        value={
                          this.props.taskDetails?.taskDescription ||
                          this.state.taskDescription
                        }
                        disabled={true}
                      />
                    </div>
                  </div>
                </div>
              </PanelBarItem>
              <PanelBarItem title={"Activity Information"} expanded={true}>
                <div className="riskRow">
                  <div className="riskCol col2">
                    <div
                      className="fieldCont"
                      title={this.state.taskActionTitle}
                    >
                      <label>Activity Title *</label>

                      <Input
                        onChange={(e) => {
                          this.setState({
                            ...this.state,
                            taskActionTitle: e.value,
                          });
                        }}
                        value={
                          this.state.taskActionTitle
                            ? this.state.taskActionTitle.trimStart()
                            : ""
                        }
                        disabled={isDisabled}
                      />
                    </div>
                  </div>
                  {this.isHiddenActivityColumn("taskActionDescription") && (
                    <div className="riskCol col6">
                      <div
                        className="fieldCont"
                        title={this.state.taskActionDescription}
                      >
                        <label>Activity Description</label>

                        <TextArea
                          onChange={(e) => {
                            this.setState({
                              ...this.state,
                              taskActionDescription: e.value,
                            });
                          }}
                          value={this.state.taskActionDescription}
                          disabled={isDisabled}
                        />
                      </div>
                    </div>
                  )}
                  {this.isHiddenActivityColumn("isApproved") && (
                    <div className="riskCol col2">
                      <div className="fieldCont">
                        <label>Approved</label>
                        <DropDownList
                          style={{ width: "100px" }}
                          onChange={(e) => {
                            this.setState({
                              ...this.state,
                              isApproved: e.target.value,
                            });
                          }}
                          data={approvedList}
                          valueField="value"
                          textField="text"
                          value={this.state.isApproved}
                          disabled={isDisabled}
                        />
                      </div>
                    </div>
                  )}
                </div>
                <div className="riskRow">
                  {this.isHiddenActivityColumn("cost") && (
                    <div className="riskCol col4">
                      <div className="fieldCont" title={this.state.cost}>
                        <label>
                          Cost of Activity / {secureLocalStorage.getItem("currency")}
                        </label>
                        <NumericTextBox
                          value={this.state.cost}
                          disabled={isDisabled}
                          onChange={(e) => {
                            this.setState({
                              ...this.state,
                              cost: e.target.value,
                            });
                          }}
                        />
                      </div>
                    </div>
                  )}
                  {this.isHiddenActivityColumn("effort") && (
                    <div className="riskCol col4">
                      <div className="fieldCont" title={this.state.effort}>
                        <label>
                          Effort /{" "}
                          {this.state.orgUnit?.effortUnitName || "Days"}
                        </label>

                        <NumericTextBox
                          value={this.state.effort}
                          disabled={isDisabled}
                          onChange={(e) => {
                            this.setState({
                              ...this.state,
                              effort: e.target.value,
                            });
                          }}
                        />
                      </div>
                    </div>
                  )}

                  {this.isHiddenActivityColumn("priorityRankingName") && (
                    <div className="riskCol col2">
                      <div className="fieldCont">
                        <label>Priority Ranking</label>
                        <DropDownList
                          onChange={(e) => {
                            this.setState({
                              ...this.state,
                              priorityRanking: e.target.value,
                            });
                          }}
                          value={this.state.priorityRanking}
                          disabled={isDisabled}
                          data={
                            this.props ? this.props.priorityRankingsList : []
                          }
                          valueField="value"
                          textField="text"
                        />
                      </div>
                    </div>
                  )}
                </div>
                <div className="riskRow">
                  {this.isHiddenActivityColumn("delayConsequence") && (
                    <div className="riskCol col4">
                      <div
                        className="fieldCont"
                        title={this.state.delayConsequence}
                      >
                        <label>Delay Consequence</label>

                        <TextArea
                          onChange={(e) => {
                            this.setState({
                              ...this.state,
                              delayConsequence: e.value,
                            });
                          }}
                          value={this.state.delayConsequence}
                          disabled={isDisabled}
                        />
                      </div>
                    </div>
                  )}
                  {this.isHiddenActivityColumn("progressComment") && (
                    <div className="riskCol col3">
                      <div
                        className="fieldCont"
                        title={this.state.progressComment}
                      >
                        <label>Progress Status</label>

                        <TextArea
                          onChange={(e) => {
                            this.setState({
                              ...this.state,
                              progressComment: e.value,
                            });
                          }}
                          value={this.state.progressComment}
                          disabled={isDisabled}
                        />
                      </div>
                    </div>
                  )}

                  {this.state.formEditFlag === true &&
                    this.isHiddenActivityColumn("progressComment") && (
                      <div className="riskCol col2">
                        <div
                          className="fieldCont progressHistory"
                          title="Progress History"
                          style={{ marginTop: "26px" }}
                        >
                          <button
                            className="btnPrimary"
                            onClick={() => this.progressHistory()}
                          >
                            Progress History
                          </button>
                        </div>
                      </div>
                    )}
                  {this.isHiddenActivityColumn("ownerName") && (
                    <div className="riskCol col2">
                      <div className="fieldCont">
                        <label> Owner</label>
                        <DropDownList
                          // style={{ width: "100px" }}
                          onChange={(e) => {
                            this.setState({
                              ...this.state,
                              taskOwner: e.target.value,
                            });
                          }}
                          value={this.state.taskOwner}
                          disabled={isDisabled}
                          data={this.props ? this.props.ownerListForRisk : []}
                          valueField="value"
                          textField="text"
                        />
                      </div>
                    </div>
                  )}
                  {this.isHiddenActivityColumn("isClosed") && (
                    <div className="riskCol col2">
                      <div className="fieldCont">
                        <label>Status</label>
                        <DropDownList
                          // style={{ width: "100px" }}
                          disabled={
                            this.state.formData.roleName === "View Only" ||
                            this.state.formData.roleName === "Standard User"
                          }
                          value={this.state.isClosed}
                          onChange={(e) => {
                            this.setState({
                              ...this.state,
                              isClosed: e.target.value,
                            });
                          }}
                          data={STATUS}
                          valueField="value"
                          textField="text"
                        />
                      </div>
                    </div>
                  )}
                </div>
              </PanelBarItem>

              {/*               
              <PanelBarItem title={"Custom Fields"}>
                <div className="riskRow">
                  {this.state.orgUnit?.customFields?.map((CfItem) => {
                    if (CfItem.inputType === "Numeric") {
                      return (
                        <div
                          className="riskCol col3"
                          key={CfItem.customFieldId}
                        >
                          <div className="fieldCont">
                            <label>{CfItem.fieldName}</label>
                            <NumericTextBox
                              value={this.getCFValue(CfItem)}
                              disabled={true}
                              onChange={(e) =>
                                this.handleCustomFieldValue(e, CfItem)
                              }
                            />
                          </div>
                        </div>
                      );
                    } else if (CfItem.inputType === "Free Text") {
                      return (
                        <div
                          className="riskCol col3"
                          key={CfItem.customFieldId}
                        >
                          <div
                            className="fieldCont"
                            title={this.getCFValue(CfItem)}
                          >
                            <label>{CfItem.fieldName}</label>
                            <TextArea
                              onChange={(e) =>
                                this.handleCustomFieldValue(e, CfItem)
                              }
                              value={this.getCFValue(CfItem)}
                              disabled={true}
                            />
                          </div>
                        </div>
                      );
                    } else if (CfItem.inputType === "Date") {
                      return (
                        <div
                          className="riskCol col3"
                          key={CfItem.customFieldId}
                        >
                          <div className="fieldCont">
                            <label>{CfItem.fieldName}</label>

                            <DatePicker
                              format="dd-MMM-yyyy"
                              id="datefield"
                              onChange={(e) =>
                                this.handleCustomFieldValue(e, CfItem)
                              }
                              value={this.getCFValue(CfItem)}
                              disabled={true}
                            />
                          </div>
                        </div>
                      );
                    } else if (CfItem.inputType === "Single Drop Down") {
                      return (
                        <div
                          className="riskCol col3"
                          key={CfItem.customFieldId}
                        >
                          <div className="fieldCont">
                            <label>{CfItem.fieldName}</label>
                            <DropDownList
                              style={{ width: "100px" }}
                              onChange={(e) =>
                                this.handleCustomFieldValue(e, CfItem)
                              }
                              value={this.getCFValue(CfItem)}
                              disabled={true}
                              data={
                                CfItem.cfPossibleValues
                                  ? CfItem.cfPossibleValues
                                  : []
                              }
                              valueField="id"
                              textField="possibleValues"
                            />
                          </div>
                        </div>
                      );
                    } else if (CfItem.inputType === "Multi Drop Down") {
                      return (
                        <div
                          className="riskCol col3"
                          key={CfItem.customFieldId}
                        >
                          <div className="fieldCont">
                            <label>{CfItem.fieldName}</label>
                            <MultiSelect
                              style={{ width: "100px !important" }}
                              onChange={(e) =>
                                this.handleCustomFieldValue(e, CfItem)
                              }
                              // onBlur={this.handleChangeBlur}
                              itemRender={this.itemRender}
                              value={this.getCFValue(CfItem)}
                              disabled={true}
                              id="customeFieldId"
                              data={
                                CfItem.cfPossibleValues
                                  ? CfItem.cfPossibleValues
                                  : []
                              }
                              valueField="id"
                              textField="possibleValues"
                              autoClose={false}
                              // tags={
                              //   selected > 0
                              //     ? [{ text: `${selected} items selected`, data: [...value] }]
                              //     : []
                              // }
                            />
                          </div>
                        </div>
                      );
                    }
                  })}
                </div>
              </PanelBarItem> */}

              <PanelBarItem title={"Additional Information"}>
                <div className="riskRow">
                  {this.isHiddenActivityColumn("departments") && (
                    <div className="riskCol col4">
                      <div className="fieldCont" title={this.state.departments}>
                        <label>Departments</label>

                        <TextArea
                          onChange={(e) => {
                            this.setState({
                              ...this.state,
                              departments: e.value,
                            });
                          }}
                          value={
                            this.state.departments
                              ? this.state.departments.trimStart()
                              : ""
                          }
                          disabled={isDisabled}
                        />
                      </div>
                    </div>
                  )}
                  {this.isHiddenActivityColumn("externalStatus") && (
                    <div className="riskCol col2">
                      <div
                        className="fieldCont"
                        title={this.state.externalStatus}
                      >
                        <label>External Status</label>

                        <Input
                          onChange={(e) => {
                            this.setState({
                              ...this.state,
                              externalStatus: e.value,
                            });
                          }}
                          value={
                            this.state.externalStatus
                              ? this.state.externalStatus.trimStart()
                              : ""
                          }
                          disabled={isDisabled}
                        />
                      </div>
                    </div>
                  )}
                  {this.isHiddenActivityColumn("weeklyReport") && (
                    <div className="riskCol col1">
                      <div
                        className="fieldCont"
                        title={this.state.weeklyReport}
                      >
                        <label>Weekly Report</label>

                        <Input
                          onChange={(e) => {
                            this.setState({
                              ...this.state,
                              weeklyReport: e.value,
                            });
                          }}
                          value={
                            this.state.weeklyReport
                              ? this.state.weeklyReport.trimStart()
                              : ""
                          }
                          disabled={isDisabled}
                        />
                      </div>
                    </div>
                  )}
                </div>
              </PanelBarItem>

              <PanelBarItem title={"Activity Progress"}>
                <div className="riskRow">
                  {this.isHiddenActivityColumn("percentageOnTrack") && (
                    <div className="riskCol col4">
                      <div
                        className="fieldCont"
                        title={this.state.percentageOnTrack}
                      >
                        <label>% on Track</label>

                        <NumericTextBox
                          value={
                            this.state.percentageOnTrack > 100
                              ? 100
                              : this.state.percentageOnTrack
                          }
                          disabled={isDisabled}
                          onChange={(e) => {
                            this.setState({
                              ...this.state,
                              percentageOnTrack: e.target.value,
                            });
                          }}
                          min={0}
                          max={100}
                        />
                      </div>
                    </div>
                  )}
                  {this.isHiddenActivityColumn("percentageCompletion") && (
                    <div className="riskCol col4">
                      <div
                        className="fieldCont"
                        title={this.state.percentageCompletion}
                      >
                        <label>% Completion</label>

                        <NumericTextBox
                          value={
                            this.state.percentageCompletion > 100
                              ? 100
                              : this.state.percentageCompletion
                          }
                          disabled={isDisabled}
                          onChange={(e) => {
                            this.setState({
                              ...this.state,
                              percentageCompletion: e.target.value,
                            });
                          }}
                          min={0}
                          max={100}
                        />
                      </div>
                    </div>
                  )}
                </div>
                <div className="riskRow">
                  {this.isHiddenActivityColumn("originalCompletionDate") && (
                    <div className="riskCol col3">
                      <div className="fieldCont">
                        <label>Original Completion Date</label>
                        <DatePicker
                          format="dd-MMM-yyyy"
                          id="datefield"
                          onChange={(e) => {
                            this.setState({
                              ...this.state,
                              originalCompletionDate: e.target.value,
                              projectedCompletionDate: e.target.value,
                            });
                          }}
                          value={this.state.originalCompletionDate}
                          disabled={isDisabled}
                          dateInput={CustomDateInput}
                        />
                      </div>
                    </div>
                  )}
                  {this.isHiddenActivityColumn("projectedCompletionDate") && (
                    <div className="riskCol col3">
                      <div className="fieldCont">
                        <label>Projected Completion Date</label>
                        <DatePicker
                          format="dd-MMM-yyyy"
                          id="datefield"
                          onChange={(e) => {
                            this.setState({
                              ...this.state,
                              projectedCompletionDate: e.target.value,
                              originalCompletionDate: this.state
                                .originalCompletionDate
                                ? this.state.originalCompletionDate
                                : e.target.value,
                            });
                          }}
                          value={this.state.projectedCompletionDate}
                          disabled={isDisabled}
                          dateInput={CustomDateInput}
                        />
                      </div>
                    </div>
                  )}
                  {this.isHiddenActivityColumn("actualCompletionDate") && (
                    <div className="riskCol col3">
                      <div className="fieldCont">
                        <label>Actual Completion Date</label>
                        <DatePicker
                          format="dd-MMM-yyyy"
                          id="datefield"
                          onChange={(e) => {
                            this.setState({
                              ...this.state,
                              actualCompletionDate: e.target.value,
                              // isClosed:STATUS[1]
                            });
                          }}
                          value={this.state.actualCompletionDate}
                          disabled={isDisabled}
                          max={new Date()}
                          dateInput={CustomDateInput}
                        />
                      </div>
                    </div>
                  )}
                </div>
              </PanelBarItem>

              <PanelBarItem title={"Proximity Alert"}>
                <div className="riskRow">
                  {this.isHiddenActivityColumn("proximityAlertDate") && (
                    <div className="riskCol col3">
                      <div className="fieldCont">
                        <label>Proximity Alert Date</label>
                        <DatePicker
                          format="dd-MMM-yyyy"
                          id="datefield"
                          onChange={(e) => {
                            this.setState({
                              ...this.state,
                              proximityAlertDate: e.target.value,
                            });
                          }}
                          value={this.state.proximityAlertDate}
                          disabled={isDisabled}
                          dateInput={CustomDateInput}
                        />
                      </div>
                    </div>
                  )}
                </div>
                <div className="riskRow">
                  {this.isHiddenActivityColumn("alertStakeHolders") && (
                    <div className="riskCol col3">
                      <div className="fieldCont" style={{ marginTop: "15px" }}>
                        <label>Alert Stakeholders</label>
                        <Autocomplete
                          multiple
                          id="emailbcc"
                          // autoSelect={true}
                          options={this.props.dropDownData.map(
                            (option) => option.displayName
                          )}
                          freeSolo
                          disableCloseOnSelect
                          onChange={this.riskalertstakeholderValue}
                          disabled={isDisabled}
                          value={this.state.alertStakeHolders}
                          renderTags={(value, getTagProps) =>
                            value.map((option, index) => (
                              <Chip
                                variant="outlined"
                                label={option}
                                {...getTagProps({ index })}
                              />
                            ))
                          }
                          PaperComponent={({ children }) => (
                            <div className="paperComponent">
                              <span>{children}</span>
                            </div>
                          )}
                          renderInput={(params) => (
                            <TextField {...params} variant="filled" />
                          )}
                        />
                      </div>
                    </div>
                  )}
                  {this.isHiddenActivityColumn("alertDescription") && (
                    <div className="riskCol col5">
                      <div
                        className="fieldCont textarea-large"
                        title={this.state.alertDescription}
                      >
                        <label>Alert Description</label>
                        <TextArea
                          value={this.state.alertDescription}
                          onChange={(e) => {
                            this.setState({
                              ...this.state,
                              alertDescription: e.value,
                            });
                          }}
                          disabled={isDisabled}
                        />
                      </div>
                    </div>
                  )}
                </div>
              </PanelBarItem>
            </PanelBar>
            <div className="btnGroup">
              <button
                type="button"
                onClick={this.saveTaskAction}
                className="btnPrimary"
                disabled={this.getDisableFlagForSubmit()}
              >
                {this.state.formEditFlag === true ? "Update" : "Add"}
              </button>
              <button
                className="btnPrimary"
                onClick={() => this.init("CANCEL")}
              >
                Cancel
              </button>
            </div>
          </div>
        </Popup>

        <Popup
          show={this.state.progressStatusFlag}
          popupClass={"popup-content popup-wrapper"}
        >
          <div className="deleteModelCont stackHolderSelection">
            <label className="fieldLabel">Progress History</label>
            <div className="commentsHistory">
              <ul className="comments">
                {this.state.formData?.actionProgressComments?.map((item) => (
                  <li>
                    <p>{item.taskActionComment}</p>
                    <small>
                      Date:
                      {moment(new Date(item.createdDate)).format(
                        "DD-MMM-yyyy HH:mm:ss"
                      )}
                    </small>{" "}
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
                    <small>Entered by:{item.userName}</small>
                  </li>
                ))}
              </ul>
            </div>
            <div className="progressBtn">
              <button
                onClick={this.closeProgressHistoryPopup}
                className="redbtn"
                type="button"
                style={{ "margin-left": "700px", "margin-bottom": "15px" }}
              >
                Cancel
              </button>
            </div>
          </div>
        </Popup>
      </div>
    );
  }
}
